import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';

export const createNfzDepartmentSelectFilter = (searchText: string | null) => (nfzDepartment: NfzDepartment): boolean =>
   searchText ? nfzDepartment.name.toLowerCase().includes(searchText.toLowerCase()) : true;
